 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannel-e096a507":"channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannel-e096a507","channelStoriesPage":"channelStoriesPage","mobileApplyPage-mobileJoinPage-mobileLoginPage":"mobileApplyPage-mobileJoinPage-mobileLoginPage","mobileLoginPage":"mobileLoginPage","mobileChangePasswordPage":"mobileChangePasswordPage","mobileExploreCategoryPage":"mobileExploreCategoryPage","mobileExploreResultsPage-mobileSearchResultsPage":"mobileExploreResultsPage-mobileSearchResultsPage","mobileExploreResultsPage":"mobileExploreResultsPage","mobileFavoritesPage":"mobileFavoritesPage","mobileFilmFest":"mobileFilmFest","mobileGifVideoPage":"mobileGifVideoPage","mobileResetPasswordPage":"mobileResetPasswordPage","vendors-gifEditPanel-storybookModal":"vendors-gifEditPanel-storybookModal","storybookModal":"storybookModal","vendors-gifEditPanel-gifMakerFinalize":"vendors-gifEditPanel-gifMakerFinalize","vendors-gifEditPanel":"vendors-gifEditPanel","gifEditPanel":"gifEditPanel","vendors-mobile404-mobileSearchResultsPage-mobileTrendingPage-reactGiphyTV":"vendors-mobile404-mobileSearchResultsPage-mobileTrendingPage-reactGiphyTV","mobile404-mobileSearchResultsPage-mobileTrendingPage":"mobile404-mobileSearchResultsPage-mobileTrendingPage","mobile404":"mobile404","mobileSearchResultsPage":"mobileSearchResultsPage","mobileTrendingPage":"mobileTrendingPage","vendors-mobileApplyPage-mobileGifMaker":"vendors-mobileApplyPage-mobileGifMaker","mobileApplyPage":"mobileApplyPage","vendors-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobile-3ed39632":"vendors-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobile-3ed39632","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobileChannelSearchPage":"mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobileChannelSearchPage","mobileChannelBranchPage":"mobileChannelBranchPage","mobileChannelLeafPage":"mobileChannelLeafPage","mobileChannelListPage":"mobileChannelListPage","mobileChannelPage":"mobileChannelPage","mobileChannelSearchPage":"mobileChannelSearchPage","vendors-gifMakerVideoTrim-mobileGifMaker":"vendors-gifMakerVideoTrim-mobileGifMaker","vendors-gifMakerFinalize-mobileGifMaker":"vendors-gifMakerFinalize-mobileGifMaker","mobileGifMaker":"mobileGifMaker","vendors-mobileDashboard":"vendors-mobileDashboard","mobileDashboard":"mobileDashboard","vendors-mobileJoinPage":"vendors-mobileJoinPage","mobileJoinPage":"mobileJoinPage","vendors-mobileTeamPage":"vendors-mobileTeamPage","mobileTeamPage":"mobileTeamPage","vendors-showdown":"vendors-showdown","gifDetailMedia":"gifDetailMedia","desktopUploadFinalize":"desktopUploadFinalize","gifMakerSlideshow":"gifMakerSlideshow","gifMakerFinalize-gifMakerVideoTrim":"gifMakerFinalize-gifMakerVideoTrim","gifMakerFinalize":"gifMakerFinalize","gifMakerVideoTrim":"gifMakerVideoTrim","aboutPage":"aboutPage","appsLanding":"appsLanding","artists":"artists","curationStation":"curationStation","desktopChannelStories":"desktopChannelStories","desktopStory":"desktopStory","desktopVideoDetail":"desktopVideoDetail","desktopVideos":"desktopVideos","filmFest":"filmFest","homebase":"homebase","homepageBeta":"homepageBeta","vendors-dvr":"vendors-dvr","dvr":"dvr"}[chunkId]||chunkId) + "." + {"0":"098be292","channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannel-e096a507":"d56c7ca7","channelStoriesPage":"6345a368","mobileApplyPage-mobileJoinPage-mobileLoginPage":"904ffdc9","mobileLoginPage":"d6307315","mobileChangePasswordPage":"eaa92396","mobileExploreCategoryPage":"88562609","mobileExploreResultsPage-mobileSearchResultsPage":"80a0f9ae","mobileExploreResultsPage":"ec2549f5","mobileFavoritesPage":"46960fe1","mobileFilmFest":"7cf1d287","mobileGifVideoPage":"32ae0773","mobileResetPasswordPage":"5f9f58d4","vendors-gifEditPanel-storybookModal":"fdf41bc5","storybookModal":"6c91f5d6","vendors-gifEditPanel-gifMakerFinalize":"899137ca","vendors-gifEditPanel":"2a226e69","gifEditPanel":"492989db","vendors-mobile404-mobileSearchResultsPage-mobileTrendingPage-reactGiphyTV":"9e0de8d4","mobile404-mobileSearchResultsPage-mobileTrendingPage":"e726809c","mobile404":"a37cb2b4","mobileSearchResultsPage":"ffa33ead","mobileTrendingPage":"6dced1ae","vendors-mobileApplyPage-mobileGifMaker":"9bc1891f","mobileApplyPage":"f9b1e94f","vendors-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobile-3ed39632":"30a9050e","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobileChannelSearchPage":"fecdee67","mobileChannelBranchPage":"6e20895e","mobileChannelLeafPage":"3341699a","mobileChannelListPage":"c21830bd","mobileChannelPage":"44d89c30","mobileChannelSearchPage":"aef2eeae","vendors-gifMakerVideoTrim-mobileGifMaker":"5bc1ce83","vendors-gifMakerFinalize-mobileGifMaker":"87618380","mobileGifMaker":"8d808684","vendors-mobileDashboard":"c81e4925","mobileDashboard":"ee3c0be7","vendors-mobileJoinPage":"31c5823b","mobileJoinPage":"7df6ca05","vendors-mobileTeamPage":"1d05a894","mobileTeamPage":"5b78f9d0","vendors-showdown":"6083c8c9","gifDetailMedia":"184c1841","desktopUploadFinalize":"b02845b7","gifMakerSlideshow":"3758c41e","gifMakerFinalize-gifMakerVideoTrim":"be06180e","gifMakerFinalize":"2f28d2cf","gifMakerVideoTrim":"bbec9dd7","aboutPage":"29f42052","appsLanding":"c92939e0","artists":"2e9992ab","curationStation":"f1fac334","desktopChannelStories":"0b38e9f3","desktopStory":"bc4b2ccc","desktopVideoDetail":"14083c4f","desktopVideos":"c98251b7","filmFest":"6a103a76","homebase":"d0fbd511","homepageBeta":"d1ce33cc","vendors-dvr":"595bc098","dvr":"3178620c"}[chunkId] + ".bundle.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
